import { createSlice } from '@reduxjs/toolkit'
import { GridSlice } from './gridReducer';
import { fetchAllDocuments } from '../fetch/fetchAllDocuments';

const loadingSlice = createSlice({
  name: 'loader',
  initialState: {
    value: false,
  },


  reducers: {


    // incremented: state => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decremented: state => {
    //   state.value -= 1
    // },
    setLoading: (state, action) => {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllDocuments.pending, (state, action) => {
      state.value = true;
    })
    builder.addCase(fetchAllDocuments.fulfilled, (state, action) => {
      state.value = false;
    })
    builder.addCase(fetchAllDocuments.rejected, (state, action) => {
      state.value = false;

    })
  },
})
export const selectLoader = (state) => state.loader.value

export const { setLoading: setLoading } = loadingSlice.actions

export default loadingSlice.reducer

